export const REMOVE_ORDER_SUCCESS = 'Order removed from workspace'
export const REMOVE_ORDER_FAIL = 'Failed to remove order from your workspace'
export const REMOVE_QUOTE_SUCCESS = 'Quote removed from workspace'
export const REMOVE_QUOTE_FAIL = 'Failed to remove quote from your workspace'
